import { RecommendedJobCard } from '../DashboardRecommendations/RecommendedJobCard';
import { RecsInterceptSurvey } from '../RecsInterceptSurvey/RecsInterceptSurvey';
import {
  isCareerFeedJob,
  isCareerFeedRecsInterceptSurvey,
  type CareerFeedItem,
} from '../hooks/feed-types';

type CareerFeedItemsProps = {
  feedItems: CareerFeedItem[];
};

const CareerFeedItem = ({
  feedItem,
  index,
}: {
  feedItem: CareerFeedItem;
  index: number;
}) => {
  if (isCareerFeedJob(feedItem)) {
    return (
      <RecommendedJobCard
        key={`recommendedJob_${feedItem.id}`}
        testAutomation={{
          jobCardLink: `recommendedJobLink_${feedItem.id}`,
        }}
        jobInfo={feedItem}
        position={index + 1}
        isFeaturedOrDisplayKeyType="feedJobs"
      />
    );
  } else if (isCareerFeedRecsInterceptSurvey(feedItem)) {
    return <RecsInterceptSurvey />;
  }

  return null;
};

export const CareerFeedItems: React.FC<CareerFeedItemsProps> = ({
  feedItems,
}) =>
  feedItems.map((feedItem, index) => (
    <CareerFeedItem key={index} feedItem={feedItem} index={index} />
  ));
